










import { Vue, Component } from 'vue-property-decorator';
import AltaTecnicoBase from './AltaTecnicoBase.vue';

@Component({
  components: { AltaTecnicoBase },
})
export default class AltaTecnicoPantalla extends Vue {}
